import { NgModule } from "@angular/core";
import { S25PanelsComponent } from "./s25.panels.component";
import { S25PanelComponent } from "./s25.panel.component";
import { S25SimpleCollapseModule } from "../s25-simple-collapse/s25.simple.collapse.module";

@NgModule({
    imports: [S25SimpleCollapseModule],
    declarations: [S25PanelsComponent, S25PanelComponent],
    exports: [S25PanelsComponent],
    providers: [S25PanelsComponent],
})
export class S25PanelsModule {}
